import { Component } from '@angular/core';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-dashboard-layout-page',
    imports: [SidebarComponent, RouterOutlet],
    templateUrl: './dashboard-layout-page.component.html',
    standalone: true,
})
export class DashboardLayoutPageComponent {

    constructor(public gs : GlobalService){}
}
